<template>
  <div class="rootDiv">
    <Cell class="cell" title="帐号" style="margin-bottom: 1rem">
      <span>{{ user.account }}</span>
    </Cell>
    <Cell class="cell" title="手机号码" is-link v-on:click.native="showPhonePopup">
      <span>{{ accounts.Phone === undefined ? "未绑定" : accounts.Phone.nC }}</span>
    </Cell>
    <Cell class="cell" title="微信号码">
      <span>暂未实现</span>
    </Cell>
    <Cell class="cell" title="QQ号码" is-link v-on:click.native="PageTo('QQ')">
      <span>{{ accounts.QQ === undefined ? "未绑定" : accounts.QQ.nC }}</span>
    </Cell>
    <Cell class="cell" title="支付宝" is-link v-on:click.native="PageTo('Alipay')">
      <span>{{ accounts.Alipay === undefined ? "未绑定" : accounts.Alipay.nC }}</span>
    </Cell>
    <Cell class="cell" title="微博" is-link v-on:click.native="PageTo('Weibo')">
      <span>{{ accounts.Weibo === undefined ? "未绑定" : accounts.Weibo.nC }}</span>
    </Cell>
    <Cell class="cell" title="百度" is-link v-on:click.native="PageTo('Baidu')">
      <span>{{ accounts.Baidu === undefined ? "未绑定" : accounts.Baidu.nC }}</span>
    </Cell>
    <Popup v-model="phonePopupVisible" style="width: 100%;padding-top: 2rem;padding-bottom: 2rem;"
           popup-transition="popup-fade">
      <div>
        <span>当前手机号码：{{ accounts.Phone !== undefined ? accounts.Phone.zH : '' }}</span>
        <br>
        <Button style="margin-top: 1rem" type="primary" @click="GetCode">更换手机号码</Button>
      </div>
    </Popup>
    <Popup v-model="accountPopupVisible" style="width: 100%;padding-top: 2rem;padding-bottom: 2rem;"
           popup-transition="popup-fade">
      <div>
        <span>当前已绑定{{
            currentAccount === null ? "" : currentAccount.zHLX
          }}帐号：{{ currentAccount === null ? "" : currentAccount.nC }}</span>
        <br>
        <Button style="margin-top: 1rem" type="primary" @click="Unbound">解除绑定</Button>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Cell, Popup, Button} from "mint-ui";
import Mine from "../Mine";
import VerificationCode from "../../../../controls/VerificationCode";

export default {
  name: "AccountSetting",
  components: {
    Cell,
    Popup,
    Button
  },
  data() {
    return {
      currentAccount: null,
      accountPopupVisible: false,
      phonePopupVisible: false,
      user: Mine.data().user,
      accounts: {
        Phone: {account: this.count},
        QQ: {account: this.count},
        Wechat: {account: this.count},
        Weibo: {account: this.count},
        Baidu: {account: this.count},
        Alipay: {account: this.count},
      },
      count: {zH: null, nC: null, lRSJ: null, zHLX: null, zHNM: null},
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      unboundAccountUrl: '/api/user/unboundAccount',
      getAccountListUrl: '/api/user/getAccountList',
      verifyCodeUrl: '/api/verifyCode/getVerifyCode',
      baiduLoginUrl: '/api/baidu/getLoginUrl',
      qqLoginUrl: '/api/qq/getLoginUrl',
      weiBoLoginUrl: '/api/weibo/getLoginUrl',
      alipayLoginUrl: '/api/alipay/getLoginUrl',
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"))
    this.getAccountList()
  },
  methods: {
    showPhonePopup() {
      if (this.accounts.Phone === undefined) {
        this.$router.push({name: 'm_binding_phone', params: {code: 'cdjcaivi'}})
      } else {
        this.phonePopupVisible = true
      }
    },
    PageTo(page) {
      let that = this
      if (this.accounts.Phone === undefined) {
        this.$messagebox.alert("请先绑定手机号码")
        return
      }
      switch (page) {
        case "QQ":
          if (this.accounts.QQ === undefined) {
            this.$ajax({
              method: 'get',
              url: this.qqLoginUrl
            }).then((response) => {
              if (response.data.result) {
                localStorage.setItem('qq_back', 'binding')
                window.location.href = response.data['responseData']
              } else {
                that.$messagebox.alert(response.data.message)
              }
            }).catch(response => {
              this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
            })
          } else {
            this.currentAccount = this.accounts.QQ
            this.accountPopupVisible = true
          }
          break
        case "Alipay":
          if (this.accounts.Alipay === undefined) {
            this.$ajax({
              method: 'get',
              url: this.alipayLoginUrl
            }).then((response) => {
              if (response.data.result) {
                localStorage.setItem('alipay_back', 'binding')
                window.location.href = response.data['responseData']
              } else {
                that.$messagebox.alert(response.data.message)
              }
            }).catch(response => {
              this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
            })
          } else {
            this.currentAccount = this.accounts.Alipay
            this.accountPopupVisible = true
          }
          break
        case "Weibo":
          if (this.accounts.Weibo === undefined) {
            this.$ajax({
              method: 'get',
              url: this.weiBoLoginUrl
            }).then((response) => {
              if (response.data.result) {
                localStorage.setItem('weibo_back', 'binding')
                window.location.href = response.data['responseData']
              } else {
                that.$messagebox.alert(response.data.message)
              }
            }).catch(response => {
              this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
            })
          } else {
            this.currentAccount = this.accounts.Weibo
            this.accountPopupVisible = true
          }
          break
        case "Baidu":
          if (this.accounts.Baidu === undefined) {
            this.$ajax({
              method: 'get',
              url: this.baiduLoginUrl
            }).then((response) => {
              if (response.data.result) {
                localStorage.setItem('baidu_back', 'binding')
                window.location.href = response.data['responseData']
              } else {
                that.$messagebox.alert(response.data.message)
              }
            }).catch(response => {
              this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
            })
          } else {
            this.currentAccount = this.accounts.Baidu
            this.accountPopupVisible = true
          }
          break
      }
    },
    getAccountList() {
      let that = this
      this.$ajax({
        method: 'get',
        url: this.getAccountListUrl,
        params: {yhnm: this.yhnm},
        headers: {token: this.token}
      }).then((response) => {
        if (response.data.result) {
          this.accounts = response.data['responseData']
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    Unbound() {
      let that = this
      that.$messagebox.confirm("确认解绑当前帐号吗?").then(action => {
        if (action === 'confirm') {
          that.$ajax({
            method: 'get',
            url: that.unboundAccountUrl,
            params: {zhnm: that.currentAccount.zHNM},
            headers: {token: that.token}
          }).then((response) => {
            that.accountPopupVisible = false
            that.$messagebox.alert(response.data.message).then(action => {
              if (action === 'confirm') {
                that.$router.go(0)
              }
            });
          }).catch(response => {
            that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
          })
        }
      })
    },
    GetCode() {
      let ver_code_ide = '1'
      let data = VerificationCode.data().requestData
      data.title = '身份验证'
      data.phone = this.accounts.Phone.zH
      data.nextPage = 'm_change_new_phone'
      data.ver_code_ide = ver_code_ide
      data.business = 'VerifyOldPhoneNumber'
      data.data = {phone: this.accounts.Phone.zH, account: this.accounts.Phone.zHNM}
      let that = this
      that.$ajax({
        method: 'get',
        url: this.verifyCodeUrl,
        params: {phoneNumber: this.accounts.Phone.zH, key: data.business}
      }).then((response) => {
        this.$toast({
          message: response.data.message,
          position: 'middle',
        });
        if (response.data.result) {
          let nowTime = new Date().getTime();
          localStorage.setItem(`startTime${ver_code_ide}`, nowTime);
          let requestData = JSON.stringify(data);
          this.$router.push({name: 'm_verification_code', query: {requestData: requestData}})
        } else {
          this.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
}

.cell {
  text-align: left;
}
</style>
